import product1 from "./TRS5/TRS5100.png";
import product1Img1 from "./TRS5/img1.jpg"
import product1Img2 from "./TRS5/img2.png"
export const marcoProducts = [
  {
    id: 1,
    name: 'TRS-5100',
    title: "TRS-5100",
    image:  product1,
    description: "Revolutionize your refraction process with effortless precision. Enhance patient comfort while achieving optimal refractive outcomes.",
    features: {
      feature1: "Provides comprehensive refraction analysis with advanced technology",
      feature2: "Enhances accuracy and efficiency compared to traditional methods",
      feature3: "Improves patient comfort and satisfaction through streamlined process",
      feature4: "Offers ergonomic design for optimized clinician workflow"
    },
    images: {
      product1Img1,
      product1Img2
    },
    link: "https://marco.com/brochures/trs5100/trs5100_broch.pdf"
  },
];